import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { UsuarioActual } from '@/views/a-login/login-controlador';
import router from '@/__env/router.index';
import { Curso } from '@/__env/lib/Cursos';
import { Utiles } from '@/__env/pluggins/event-bus';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';
import { Cliente } from '@/__env/lib/Clientes';
import { Viajante } from '@/__env/lib/Ventas/Viajantes/Viajante.nav';
import { Articulo } from '@/__env/lib/Articulos';
import { Turnero } from '@/__env/lib/Turnero';

export class ControladorDeInicio
{
    public get Usuario() { return UsuarioActual; }
    public Turnero: Turnero = new Turnero();

    public readonly Vista = new Vista();

    public async Iniciar()
    {
        this.Turnero = await Turnero.create( 1 );
        this.Vista.Estado = 'iniciado';
    }

    public async Siguiente()
    {
        //await this.Turnero.Siguiente();

    }

}

type Opcion = {
    Icono?: string,
    Titulo?: string,
    Subtitulo?: string,
    Modo?: string,
    Resaltado?: boolean,
    Oculto?: boolean,
    Accion?: Function,
    Tipo: 'opcion' | 'titulo',
};


type Modo =
    string |
    'vacio' |
    'detalles' |
    'lista' |
    'crear'

    ;

type SubModo =
    'vacio' |
    'configuracion-usuario' |
    'notificaciones';
'chat'
    ;

type Estado = 'iniciado' | 'cargando' | 'error' | 'mod';
type Buscador =
    'vacio' |
    'ninguno';

class Vista
{
    public readonly Titulo: string = 'Configuración';
    public get SubTitulo(): string
    {
        let e = this.Opciones.find( x => x.Modo == this.modo );
        if ( e )
            return e.Titulo;
    }

    public Opciones: Opcion[] = [

        { Tipo: 'titulo', Titulo: '' },
        { Tipo: 'opcion', Icono: 'home-outline', Modo: 'inicio', Titulo: 'Inicio' },
        { Tipo: 'opcion', Icono: 'chart-timeline-variant', Modo: 'situacion-empresa', Titulo: 'Situación empresa' },
        { Tipo: 'opcion', Icono: 'account-outline', Modo: 'clientes', Titulo: 'Clientes' },
        { Tipo: 'opcion', Icono: 'briefcase-outline', Modo: 'viajantes', Titulo: 'Viajantes' },
        { Tipo: 'opcion', Icono: 'package-variant-closed', Modo: 'articulos', Titulo: 'Artículos' },
        { Tipo: 'opcion', Icono: 'book-open-page-variant', Modo: 'cursos', Titulo: 'Cursos' },


        { Tipo: 'opcion', Modo: 'cliente', Titulo: 'Cliente', Oculto: true },
        { Tipo: 'opcion', Modo: 'viajante', Titulo: 'Viajante', Oculto: true },
        { Tipo: 'opcion', Modo: 'articulo', Titulo: 'Artículo', Oculto: true },

    ];

    protected modo: Modo = 'creados';
    get Modo(): Modo { return this.modo; }
    set Modo( m: Modo )
    {
        this.modo = m;
        this._onModo.dispatch();
        this.query = {};
        this.query['m'] = this.modo;
        Utiles.setQuery( this.query );
        this.MenuAbierto = false;
    }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    protected query: Record<string, string> = {};
    public set Query( x: Record<string, string> )
    {
        this.query = x;
        this.query['m'] = this.modo;
        Utiles.setQuery( this.query );
    }
    private _onEditarQuery = new SimpleEventDispatcher<string>();
    public get onEditarQuery() { return this._onEditarQuery.asEvent(); }

    protected submodo: SubModo = 'vacio';
    get SubModo(): SubModo { return this.submodo; }
    set SubModo( m: SubModo ) { this.submodo = m; this._onSubModo.dispatch(); }
    private _onSubModo = new SignalDispatcher();
    public get onSubModo() { return this._onSubModo.asEvent(); }

    protected menuAbierto: boolean = true;
    get MenuAbierto(): boolean { return this.menuAbierto; }
    set MenuAbierto( m: boolean ) { this.menuAbierto = m; this._onMenuAbierto.dispatch(); }
    private _onMenuAbierto = new SignalDispatcher();
    public get onMenuAbierto() { return this._onMenuAbierto.asEvent(); }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    protected buscador: Buscador = 'ninguno';
    get Buscador(): Buscador { return this.buscador; }
    set Buscador( m: Buscador ) { this.buscador = m; this._onBuscador.dispatch(); }
    private _onBuscador = new SignalDispatcher();
    public get onBuscador() { return this._onBuscador.asEvent(); }



}

export const Controlador = new ControladorDeInicio();


